import React from 'react';

import { useInputConfigurationProviderContext } from '../InputConfigurationProvider';
import { AllProps, DeferWrapperProps, ExpectedComponent } from './index.types';
import { DeferWrapperView } from './index.view';

export function DeferWrapper<
  T,
  Props extends AllProps<T>,
  K extends ExpectedComponent<Props>,
>(props: DeferWrapperProps<T, Props, K>) {
  const { deferWrapper } = useInputConfigurationProviderContext();

  if (deferWrapper?.enabled !== undefined && deferWrapper?.enabled === false) {
    const Component = props.component;
    console.log('Rendering component directly as deferWrapper is disabled');
    return (
      <Component
        {...({} as any)}
        {...props.componentsProps}
        value={props.latestValue}
        onChange={props.onChange}
      />
    );
  }

  return <DeferWrapperView {...props} />;
}

export default DeferWrapper;
export type { DeferWrapperProps } from './index.types';
